<template>
  <div class="fixed inset-0 bg-black/80 bg-opacity-50 flex items-center justify-center z-50" @click="$emit('close')">
    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4 shadow-xl" @click.stop>
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Connect Wallet</h2>
        <button
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div v-if="walletStore.error" class="mb-4 p-3 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 rounded">
        {{ walletStore.error }}
      </div>

      <div class="space-y-3">
        <div
          v-for="wallet in walletStore.wallets"
          :key="wallet.name"
          class="flex items-center p-3 border border-gray-200 dark:border-gray-600 rounded-lg hover:border-caas-primary hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
          @click="handleConnect(wallet.name)"
        >
          <img :src="wallet.icon" :alt="wallet.name" class="w-8 h-8 mr-3 rounded" />
          <span class="text-gray-900 dark:text-white font-medium">
            {{ wallet.name }}
          </span>

          <div v-if="walletStore.isConnecting" class="ml-auto">
            <svg
              class="animate-spin h-5 w-5 text-caas-primary"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>
        </div>
      </div>

      <div v-if="walletStore.wallets.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
        No wallets available. Please install a supported wallet extension.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useWalletStore } from '@/stores/wallet';

  const emit = defineEmits<{
    close: [];
  }>();

  const walletStore = useWalletStore();

  async function handleConnect(walletName: string) {
    await walletStore.connect(walletName);
    if (walletStore.isConnected) {
      emit('close');
      window.localStorage.setItem('wallet', walletName);
    }
  }
</script>
